// ============================================================
// api/carePlanRoles.js  (Care Coordinator, role-model expansion Push 2)
// Admin-portal client for the CarePlan module-role endpoints. Clone of
// api/careChargeRoles.js against the coordinator overlay (single vocabulary
// 'care_coordinator'; no tier).
//
// Backend reference:
//   admin-careplan-role-get.js    (GET    -> { coreRole, coreRoleApplicable, current, history })
//   admin-careplan-role-grant.js  (POST   { carePlanRole })
//   admin-careplan-role-revoke.js (DELETE -> { revoked, carePlanRole? })
//
// One path, three methods: /api/mgmt/admin/users/{clientUserId}/careplan-role
// ============================================================

import { apiGet, apiPost, apiDelete } from './client';

export async function getCarePlanRole(clientUserId) {
  return apiGet(`/mgmt/admin/users/${clientUserId}/careplan-role`);
}

export async function grantCarePlanRole(clientUserId, { carePlanRole }) {
  return apiPost(`/mgmt/admin/users/${clientUserId}/careplan-role`, { carePlanRole });
}

export async function revokeCarePlanRole(clientUserId) {
  return apiDelete(`/mgmt/admin/users/${clientUserId}/careplan-role`);
}
